/* eslint-disable @typescript-eslint/no-explicit-any */
import { StateCreator } from 'zustand';
import { produce } from 'immer';
import { createAppStore } from './zustand';

export interface DCAPageModelState {
  pageModel: unknown;
}
export interface DCAPageModelActions {
  setPageModel: (pageModel: unknown) => void;
  updateComponent: (componentKey: string, data: unknown, path: string) => void;
}

const initialState: DCAPageModelState = {
  pageModel: {},
};

export type DCAPageModelStoreType = ReturnType<typeof createDCAPageModelStore>;

export const createDCAPageModelStore: StateCreator<DCAPageModelState & DCAPageModelActions> = set => {
  return {
    ...initialState,
    setPageModel: (data: any) => {
      set({ pageModel: data });
    },
    updateComponent: (componentKey: string, data: unknown, path: string) => {
      // Security: Prevent prototype pollution by blocking dangerous property names
      const PROTOTYPE_POLLUTION_PROPS = ['__proto__', 'constructor', 'prototype'];
      if (PROTOTYPE_POLLUTION_PROPS.includes(componentKey)) {
        console.warn(`Security: Blocked attempt to set dangerous property: ${componentKey}`);
        return;
      }

      set((state: DCAPageModelState) =>
        produce(state, (draft: any) => {
          if (draft.pageModel.cqItems) {
            const allKeys = path?.split('.') || [];
            allKeys.pop(); // Extract the last key for assignment
            // Security: Validate path keys to prevent prototype pollution
            if (allKeys.some(key => PROTOTYPE_POLLUTION_PROPS.includes(key))) {
              console.warn(`Security: Blocked attempt to use dangerous path key`);
              return;
            }
            const proxy = allKeys.reduce((acc, key) => acc?.[key], draft.pageModel);
            // Security: Only assign if proxy is a valid object and componentKey is safe
            if (
              proxy &&
              typeof proxy === 'object' &&
              !Array.isArray(proxy) &&
              proxy !== null &&
              !PROTOTYPE_POLLUTION_PROPS.includes(componentKey)
            ) {
              proxy[componentKey] = data;
            }
          }
        })
      );
    },
  };
};

export const useDCAPageModelStore = createAppStore(createDCAPageModelStore);
